import React from "react";
import { RichText, VisitorIdentification } from "@sitecore-jss/sitecore-jss-react";
import Helmet from "react-helmet";
import "../styles/main.scss";
import "../assets/app.css";
/*
  APP LAYOUT
  This is where the app's HTML structure and root placeholders should be defined.

  All routes share this root layout by default (this could be customized in RouteHandler),
  but components added to inner placeholders are route-specific.
*/
const LayoutEmail = ({ route, path, lang, noHeaderFooter, server }) => (
  <React.Fragment>
    {/* react-helmet enables setting <head> contents, like title and OG meta tags 12*****12 */}
    <Helmet>
      <meta name="description" content={(route.fields && route.fields.pageDescription && route.fields.pageDescription.value) || ""} />
      <meta name="Keywords" content={(route.fields && route.fields.pageKeywords && route.fields.pageKeywords.value) || ""} />
      <title>{(route.fields && route.fields.pageTitle && route.fields.pageTitle.value) || "Page"}</title>
    </Helmet>
    <VisitorIdentification />
    <RichText field={route.fields.content} />
  </React.Fragment>
);

export default LayoutEmail;
